import angular from "angular";
import geojsonBuilderService from './geojsonBuilder.service';

let geojsonBuilderModule = angular.module('geojsonBuilder.service', [])
.service('GeojsonBuilder', geojsonBuilderService)
.name;

export default geojsonBuilderModule;



// WEBPACK FOOTER //
// ./client/app/services/geojsonBuilder/geojsonBuilder.js